import {
  POKER_CONFIGURATION_PAGES,
  type PokerConfigurationPageKey,
} from "../../../utils/constants/poker/pokerConfigurationData";
import { PokerConfigurationPlaceholder } from "./PokerConfigurationPlaceholder";
import CashGameLimits from "./cash-game-limits/CashGameLimits";

type PokerConfigurationPageProps = {
  pageKey: PokerConfigurationPageKey;
};

function PokerConfigurationPage({ pageKey }: PokerConfigurationPageProps) {
  if (pageKey === "cashGameLimits") {
    return <CashGameLimits />;
  }
  const page = POKER_CONFIGURATION_PAGES[pageKey];
  return <PokerConfigurationPlaceholder page={page} />;
}

export default PokerConfigurationPage;
